/* eslint-disable @typescript-eslint/no-explicit-any */
import requestAuth from 'utils/requestAuth';
import request from 'utils/request';

const customersService = {
  getList: (params: any) => requestAuth.get('/customer', { params }),
  getById: (id: string) => requestAuth.get(`/customer/${id}`),
  getListDebtsById: (id: string) => request.get(`/dc/customer/${id}`),
  create: (data: any) => requestAuth.post('/customer', data),
  update: (data: any) => requestAuth.put(`/customer`, data)
};

export default customersService;
